import Icon from "./icon";

export { Icon };
export default Icon;
